import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { VideosProcessed } from "app/@core/models/videos-processed";
import { HttpService } from "app/@core/services/http.service";
import { NotificationService } from "app/@core/services/notification.service";
import { HeaderComponent } from "app/@theme/components";
import { AppSettings } from "app/app-settings";
import { AccountService } from "app/pages/account/shared/account.service";
import { BulkDeleteDialogComponent } from "app/pages/video-upload-process/components/bulk-delete/bulk-delete-dialog/bulk-delete-dialog.component";
import { VideoUploadStep1Component } from "app/pages/video-upload-process/video-upload-step1/video-upload-step1.component";
import { VideoUploadStep2Component } from "app/pages/video-upload-process/video-upload-step2/video-upload-step2.component";
import { VideoUploadStep3Component } from "app/pages/video-upload-process/video-upload-step3/video-upload-step3.component";

@Component({
  selector: "ngx-two-column-layout",
  styleUrls: ["./two-columns.layout.scss"],
  template: `
    <nb-layout windowMode>
      <nb-layout-header class="main-header">
        <ngx-header></ngx-header>
      </nb-layout-header>

     <nb-sidebar class="menu-sidebar"
        tag="menu-sidebar"
        *ngIf="showLeft"
        responsive
        start
      >
        <button class="uploadPanel" (click)="openBulkDeleteSelectionPopUp('bulk')" >
          BULK DELETE 
        </button>

        <button class="uploadPanel" style="height:7% !important;position : relative !important;bottom:25px !important;"
         (click)="openBulkDeleteSelectionPopUp('duplicate')" >
          DELETE DUPLICATES 
        </button>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
//<ng-content select="nb-menu"></ng-content>
export class TwoColumnsLayoutComponent {
  showLeft: boolean = true;
  videosInProgress = [];
  totalProgress = 0;
  socketStatus: Boolean = true;
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private videoProcessed: VideosProcessed,
    private notificationService: NotificationService,
    private httpService: HttpService,
    public accountService: AccountService
  ) {
    accountService.isEnabled('VIDEO_UPLOADER')
    this.showLeft = false;
    this.videosInProgress = videoProcessed.currentValue;
    if (this.videosInProgress != null) {
      this.totalProgress = this.videoProcessed.calculateTotalProgress;
    }

    notificationService.connectionStatus.subscribe((data: Boolean) => {
      //console.log("Socket Connection : ", data);
      if (data) this.socketStatus = data;
      else this.socketStatus = false;
    });
  }

  ngOnInit(): void {
    this.videoProcessed.current.subscribe((data) => {
      this.videosInProgress = data;
      if (this.videosInProgress != null) {
        this.totalProgress = this.videoProcessed.calculateTotalProgress;
        //console.log(this.totalProgress);
      }

      //console.log("TwoColumn - " + this.totalProgress);
    });
  }

  openUploadPopUp() {
    if (this.socketStatus) {
      this.dialog.open(VideoUploadStep1Component, {
        //height:'400px',
        width: "50%",
        autoFocus: false,
      });
    } else {
      this.httpService.openErrorDialog(this.httpService.appOfflineMessage);
    }
  }

  openProgressPopUp() {
    this.dialog.open(VideoUploadStep3Component, {
      //height:'400px',
      width: "65%",
      autoFocus: false,
    });
  }
  
  openBulkDeleteSelectionPopUp(data  :any) {
    this.dialog.open(BulkDeleteDialogComponent, {
      autoFocus: false,
      data : data
    });
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['login']);
    // window.location.href = "/";
  }
}
